import { DateStrategyAssign } from "app/shared/model/EditPricelist";
import { DateStrategy, IsoDayOfWeek } from "app/shared/model/EditProductOffering";
import { toIso } from "../date/iso";

export const WORKING_WEEKS_WEEKDAY_START_MESSAGE =
  "Products with a Working Weeks unit type must start on a weekday (Monday-Friday).";

export const WORKING_WEEKS_UNIT_TYPE_ID = 6;

export function isWorkingWeeksUnitType(
  unitTypeId?: number | null,
  unitTypeName?: string | null
): boolean {
  if (Number(unitTypeId) === WORKING_WEEKS_UNIT_TYPE_ID) return true;
  return (unitTypeName ?? "").toLowerCase().includes("working");
}

export function isWeekendDate(date: string | Date | undefined): boolean {
  const iso = toIso(date);
  if (!iso) return false;
  const day = new Date(iso).getUTCDay();
  return day === 0 || day === 6;
}

export function validateWorkingWeeksDateStrategy(
  strategy: DateStrategyAssign,
  unitTypeId?: number | null,
  unitTypeName?: string | null,
  skipCopiedDateStrategies?: boolean
): string | null {
  if (!isWorkingWeeksUnitType(unitTypeId, unitTypeName)) return null;
  if (skipCopiedDateStrategies && !strategy.isNew) return null;

  const strategyName = DateStrategy[strategy.strategyTypeId];

  if (strategyName === "Specific Start Dates") {
    const hasWeekendStart = (strategy.specificStartDates ?? []).some(
      (d) => !d.isDeleted && isWeekendDate(d.date)
    );
    if (hasWeekendStart) return WORKING_WEEKS_WEEKDAY_START_MESSAGE;
  }

  if (strategyName === "Recurrence") {
    const days = strategy.recurranceStartDays ?? [];
    if (days.includes(IsoDayOfWeek.Saturday) || days.includes(IsoDayOfWeek.Sunday)) {
      return WORKING_WEEKS_WEEKDAY_START_MESSAGE;
    }
  }

  return null;
}

export function validateOfferingWorkingWeeksDateStrategies(
  offering: {
    unitTypeId?: number | null;
    unitTypeName?: string | null;
    unitTypeText?: string | null;
    dateStrategyAssignments?: DateStrategyAssign[];
    isNew?: boolean;
  },
  skipCopiedDateStrategies?: boolean
): string | null {
  const unitTypeId = offering.unitTypeId;
  const unitTypeName = offering.unitTypeName ?? offering.unitTypeText;
  const skipCopied = skipCopiedDateStrategies && offering.isNew !== true;

  for (const ds of offering.dateStrategyAssignments ?? []) {
    if (!ds || ds.isArchived) continue;
    const error = validateWorkingWeeksDateStrategy(
      ds,
      unitTypeId,
      unitTypeName,
      skipCopied
    );
    if (error) return error;
  }

  return null;
}
